// extracted by mini-css-extract-plugin
export default {"container":"UserLayout_container__lRveS","wrapper":"UserLayout_wrapper__z5cOz"};